<template>
  <div class="modal-text">
    <p>
      Dans un projet CodeSnippet, vous trouverez trois fichiers, chacun écrit
      dans un langage différent. Voici la liste ces <b>trois fichiers</b>, pour
      mieux comprendre la structure d'un projet CodeSnippet :
    </p>
    <div class="p-d-flex p-ai-center mt-3 chip-block">
      <Chip label="HTML" class="custom-chip mr-2" />
      <p>
        Langage de balises qui structure et donne du sens à une page web. Ce
        langage sert notamment à distinguer les paragraphes, tableaux, vidéos,
        images.
      </p>
    </div>
    <div class="p-d-flex p-ai-center mt-3 chip-block">
      <Chip label="CSS" class="custom-chip mr-2" />
      <p>
        Langage de règles de style qui permet de mettre en forme le contenu HTML
        et de le styliser. On peut y définir les couleurs du site, la taille des
        images, etc.
      </p>
    </div>
    <div class="p-d-flex p-ai-center mt-3 chip-block">
      <Chip label="JavaScript" class="custom-chip mr-2" />
      <p>
        Langage de programmation qui permet de rendre le contenu d'une page web
        dynamique. Il sert, par exemple, aux formulaires, boutons, etc.
      </p>
    </div>
    <p class="mt-3">
      Une fois ces fichiers assemblés, ceux-ci vous permettront de réaliser des
      sites web simples mais efficaces ! Ces trois fichiers seront uniques pour
      chaque groupe d'utilisateurs dans un projet, et notre outil de
      prévisualisation vous permettra de voir en direct le rendu de votre code.
    </p>
    <p class="mt-3">
      Pour en apprendre plus sur le développement web, vous pouvez consulter
      <a
        class="underline"
        title="Documentation pour en apprendre plus sur le développement web"
        href="https://developer.mozilla.org/fr/docs/Learn/Getting_started_with_the_web"
      >
        le guide "Commencer avec le Web" par MDN Web Docs
      </a>
    </p>

    <hr class="my-5" />

    <h3>Liens utiles</h3>

    <ul class="list-disc list-inside">
      <li class="my-1">
        <router-link class="link" :to="{ name: 'Create Project' }">
          <span>Créer un nouveau projet</span>
        </router-link>
      </li>
      <li class="my-1">
        <router-link class="link" :to="{ name: 'Dashboard' }">
          <span>Retrouves mes projets</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ConnectionDialogContent",
};
</script>
